import { StatusCode } from './status';

export class ReleaseEntrance {
  nationalId!: string;
  name!: string;
  reason!: string;
  profile!: number;
  turnstileId!: number;
  jwt!: string;
}

export class CredentialEntered {
  eventId!: string;
  name?: string;
  nationalId!: string;
  photo!: string;
  statusCode!: StatusCode;
  birthdate?: string;
}

export enum TypeMessageSignalR {
  CredentialEntered,
  ReleaseEntrance
}

export class MessageSignalR {
  type!: TypeMessageSignalR;
  data!: any;
}
